import { render, staticRenderFns } from "./self_diagnosis_breed.vue?vue&type=template&id=5a7f1f3e&scoped=true"
import script from "./self_diagnosis_breed.vue?vue&type=script&lang=js"
export * from "./self_diagnosis_breed.vue?vue&type=script&lang=js"
import style0 from "./self_diagnosis_breed.vue?vue&type=style&index=0&id=5a7f1f3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7f1f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a7f1f3e')) {
      api.createRecord('5a7f1f3e', component.options)
    } else {
      api.reload('5a7f1f3e', component.options)
    }
    module.hot.accept("./self_diagnosis_breed.vue?vue&type=template&id=5a7f1f3e&scoped=true", function () {
      api.rerender('5a7f1f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/self_diagnosis_breed.vue"
export default component.exports